export const forms = {
	validation: {
		required: "{{field}} er påkrævet",
		min: "{{field}} skal være mindst {{min}} tegn",
		max: "{{field}} må højst være {{max}} tegn",
		invalid: "{{field}} er ikke gyldig",
		lowercase: "{{field}} skal indeholde mindst ét lille bogstav",
		uppercase: "{{field}} skal indeholde mindst ét stort bogstav",
		number: "{{field}} skal indeholde mindst ét tal",
		special_character: "{{field}} skal indeholde mindst ét specialtegn",
	},
	email: {
		label: "E-mail",
		placeholder: "you@example.dk",
	},
	password: {
		label: "Lösenord",
		placeholder: "Angiv adgangskoder",
		password_match: "Adgangskoder skal være ens",
	},
	first_name: {
		label: "Fornavn",
		placeholder: "John",
	},
	last_name: {
		label: "Efternavn",
		placeholder: "Doe",
	},
};
